import { createContext, ReactNode } from 'react';

type props = [cellClick: ((e: any) => any) | undefined];
export const EditCellContext = createContext<props | []>([]);

type GridContextProviderProps = {
  children: ReactNode;
  value: props;
};

const EditCellContextProvider = ({ children, value }: GridContextProviderProps) => (
  <EditCellContext.Provider value={value}>{children}</EditCellContext.Provider>
);

export default EditCellContextProvider;
